import AccessoryDetails from "./AccessoryDetails.vue";

const accessoryDetailsCtrl = new Vue({
    el: '#accessory-details',
    components: {AccessoryDetails},
})
